import script from "./InvoiceManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceManagement.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceManagement.vue?vue&type=style&index=0&id=d1cdc1e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1cdc1e0"]])

export default __exports__